export class ContentSessionTimeOut {
  sessionTimeoutMessageTitle: any;
  sessionTimeoutMessageDescription: any;
  logOutText: any;
  loggedInText: any;
  sessionTimeoutID: any;
  timeoutStayLogInText: any;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['sessionTimeoutMessageTitle']) {
        this.sessionTimeoutMessageTitle =
          contentjson['sessionTimeoutMessageTitle'];
      }
      if (contentjson['sessionTimeoutMessageDescription']) {
        this.sessionTimeoutMessageDescription =
          contentjson['sessionTimeoutMessageDescription'];
        this.timeoutStayLogInText =
          contentjson['sessionTimeoutMessageDescription'];
      }
      if (contentjson['logOutText']) {
        this.logOutText = contentjson['logOutText'];
      }
      if (contentjson['loggedInText']) {
        this.loggedInText = contentjson['loggedInText'];
      }
      if (contentjson['sessionTimeoutID']) {
        this.sessionTimeoutID = contentjson['sessionTimeoutID'];
      }
    }
  }
}
